var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sports-page racing pm" },
    [
      _c(
        "v-layout",
        { staticClass: "page-layout" },
        [
          _c(
            "v-flex",
            {
              ref: "maincolumn",
              staticClass: "main-column",
              style: { paddingTop: _vm.headerHeight + "px" }
            },
            [
              _c("resize-observer", { on: { notify: _vm.mainColumnResize } }),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "page-layout" },
                [
                  _c(
                    "v-flex",
                    { staticClass: "center-column" },
                    [
                      _c("racecardnav"),
                      _vm._v(" "),
                      _vm.racecardOptConf && _vm.racecardOptConf.layout
                        ? _c("racecard", {
                            attrs: {
                              rcconf: _vm.racecardOptConf,
                              rcfilter: _vm.racecardOptFilter,
                              rcsort: _vm.racecardOptSort,
                              rcidtgmeeting: _vm.idtgmeeting
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRaceBetting || _vm.pmShowBetSlip
                        ? _c("pool")
                        : _vm.showRaceInfo
                        ? _c("race-info", { attrs: { raceid: _vm.idtgrace } })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tabletAndAbove
                    ? _c(
                        "v-flex",
                        { staticClass: "betslip-column" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "toggleBetslipColumn",
                              class: [
                                { loggedIn: _vm.isLoggedIn },
                                _vm.brandKey
                              ]
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "betslipTabs noHistory",
                                  class: [{ loggedIn: _vm.isLoggedIn }]
                                },
                                [
                                  _c("span", { staticClass: "tab active" }, [
                                    _c(
                                      "a",
                                      { staticClass: "betsliptablink a-link-" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("Betslip.PM.Title"))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.mobileBigAndBelow
                                          ? _c("badge", [
                                              _vm._v(
                                                _vm._s(_vm.selectedRunnersCount)
                                              )
                                            ])
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("betslip")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog-betslip-msg",
            persistent: "",
            fullscreen: false
          },
          model: {
            value: _vm.dialogBetslipMsg.active,
            callback: function($$v) {
              _vm.$set(_vm.dialogBetslipMsg, "active", $$v)
            },
            expression: "dialogBetslipMsg.active"
          }
        },
        [
          _c("betslip-msg", {
            attrs: { dialogBetslipMsg: _vm.dialogBetslipMsg }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bc26073", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc26073","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PariMutuel.vue
// module id = null
// module chunks = 